<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  font-family: monospace;
}
code {
  color: cornflowerblue;
}
</style>



// WEBPACK FOOTER //
// src/App.vue